import type { ErrorLike } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

import { ApiErrorCodes, ApiErrorRules } from '@constants/apiErrors';

const containsErrorCode = (code: string, error?: Nullable<ErrorLike>) => {
  if (!error || !CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some((err) => err.extensions?.code === code);
};

const isConstraintError = (rule: ApiErrorRules, error?: ErrorLike) => {
  if (!error || !containsErrorCode(ApiErrorCodes.failedRule, error)) {
    return false;
  }

  if (!CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some((err) => err.extensions?.rule === rule);
};

const containsConstraintError = (errors: ErrorLike[], rule: ApiErrorRules) =>
  errors.some((error) => isConstraintError(rule, error));

export { isConstraintError, containsConstraintError, containsErrorCode };
